import type { DrillSession } from "../../lib/fingerspelling-drill-session";

type DrillResultProps = {
  session: Extract<DrillSession, { status: "finished" }>;
  onRetry: () => void;
  onBack: () => void;
};

/** ドリル1回の終了画面。つくるは採点しないので、正解数を出さない */
export const DrillResult = ({ session, onRetry, onBack }: DrillResultProps) => (
  <div className="flex min-h-[calc(100svh-7rem)] flex-col items-center justify-center gap-4 text-center">
    <p className="text-2xl font-bold">
      {session.settings.mode === "read"
        ? `${session.total}もん中 ${session.correctCount}もん せいかい`
        : `${session.total}もん おわり！`}
    </p>
    <button
      type="button"
      onClick={onRetry}
      className="select-none touch-manipulation rounded-2xl bg-blue-600 px-6 py-3 text-lg font-semibold text-white [-webkit-touch-callout:none]"
    >
      もういちど
    </button>
    <button
      type="button"
      onClick={onBack}
      className="touch-manipulation text-sm text-neutral-600 underline"
    >
      えらびかたへ もどる
    </button>
  </div>
);
